import { isDarkTheme } from "@fe/theme/is-dark-theme";
import { useColorSchemeStore } from "@fe/theme/use-color-scheme.store";
import { useMediaQuery } from "./use-media-query";

export function useIsDarkMode() {
	const theme = useColorSchemeStore((s) => s.theme);
	const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");

	return isDarkTheme({ theme, prefersDark });
}
